export enum JobType {
  COPY = "copy",
  MOVE = "move",
  RENAME = "rename",
}

export enum JobStatus {
  PENDING = "pending",
  RUNNING = "running",
  ABORTED = "aborted",
  CANCELED = "canceled",
  COMPLETED = "completed",
}

interface FileJob {
  id: number;
  source: string;
  destination: string;
  job_type: JobType;
  status: JobStatus;
  created_by?: string;
  created_at?: string;
  file_count?: number;
  transfer_size?: number;
  completed_at?: string;
  canceled_at?: string;
  aborted_at?: string;
  progress?: {
    source: string;
    destination: string;
    error_message: string;
    file_size: number;
  }[];
}

export default FileJob;
